import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../service.service';

class ImageSnippet {
  constructor(public src: string, public file: File) {}   //image uploading
}


@Component({
  selector: 'app-edit-brand',
  templateUrl: './edit-brand.component.html',
  styleUrls: ['./edit-brand.component.css']
})
export class EditBrandComponent implements OnInit {

  constructor(private brandService:ServiceService) { }

  output:any=[]; //---store get() result--------
  selectedFile: ImageSnippet | undefined;   //image uploading
  //getUrl='http://192.241.151.66:5000/viewBrands';
  data:any={}
  isShown: boolean = false;
  alert=""
  message=""
  name=""
  ImageName="";
  searchEmployee:string='';
  isShownEmployee=true;
  employee:any=[];
  //uploadUrl="http://192.241.151.66:5000/updateBrands/brand_image"
  //putUrl="http://192.241.151.66:5000/updateBrands"

  //--------function for shown the alert----------
 shown(){
  this.isShown=false
}
  //for showing notifivation
  notification(){
  this.isShown = !this.isShown;
 }
 
  //---call function in service for brand Id------
  brandId=this.brandService.getBrandId()

//----------------image uploading---------------------------------
processFile(imageInput: any) {

  const file: File = imageInput.files[0];
  const reader = new FileReader();
  reader.addEventListener('load', (event: any) => {

    this.selectedFile = new ImageSnippet(event.target.result, file);
    const formData = new FormData();
    formData.append('brand_id',this.brandId);
    formData.append('brand_image',this.selectedFile.file);

    console.log('brand_image',this.selectedFile.file.name)
    this.ImageName=this.selectedFile.file.name
    this.name=this.selectedFile.file.name

    this.brandService.UploadImage(formData).subscribe((res)=>{
    this.message=res.message
    console.log("Message=",this.message)
      })
  });

  reader.readAsDataURL(file);
}
//----------------remove image---------------------------------
RemoveFile() {

    const formData = new FormData();
    formData.append('brand_id',this.brandId);
    formData.append('brand_image',"");

    this.brandService.UploadImage(formData).subscribe((res)=>{
    this.message=res.message
    console.log("Message=",this.message)
      })
  
}
//---------function for edit brand detail-----
btnClick()
{
  
  //--------api for put----------//
  this.brandService.UpdateBrand(this.data).subscribe((res) => {
    
    this.alert=res.message;
    console.log("res=",this.alert);

  })
}
  //-------------function for search--------------------
  SearchEmployee(){
    console.log("In search=",this.data.brand_manager);
    if(this.data.brand_manager_name!='')
    {
    this.isShownEmployee=true;
    }
    this.searchEmployee=this.data.brand_manager_name
    this.brandService.SearchEmployee(this.searchEmployee).subscribe((res)=>{
    this.employee=res.data;
   
    })
  }
  //---------function for getting searched employee id---------------
getEmployeeId(value1:any,value2:any){
     
  this.isShownEmployee=false
  //this.searchEmployee=value2
  //this.employee_id=value1
  this.data.brand_manager_name=value2
  this.data.brand_manager_id=value1
 // console.log("search result",this.data.employee_id)
}
  ngOnInit(): void {

    //-------api get()calling-------------
    this.brandService.ViewBrandById('/'+this.brandId).subscribe((res)=>{
      this.output=res.data
      this.data={
        brand_code:this.output[0].brand_code,
        brand_name:this.output[0].brand_name,
        brand_id:this.output[0].brand_id,
        brand_manager_name:this.output[0].brand_manager_name
     }
     this.name=this.output[0].brand_images
    })
  }

}
